import { render } from "./denyWizard.vue?vue&type=template&id=53889ac0"
import script from "./denyWizard.vue?vue&type=script&lang=js"
export * from "./denyWizard.vue?vue&type=script&lang=js"

import "./denyWizard.vue?vue&type=style&index=0&id=53889ac0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__